module.exports = __webpack_public_path__ + "static/2-2ae7018566965a25b10c9b7c65765648.jpg";